import { action } from "mobx";
import { observer } from "mobx-react";
import { Button } from "primereact/button";
import React, { useContext } from "react";
import { useLocStore } from "../../wsLocalization";
import { LocContext } from "../../wsLocalization/LocContext";
import { scrollIntoView } from "../../WSUtils/scrollIntoView";
import { redirect } from "../../WSUtils/urlUtils";
import { UserInfoContext } from "../../WSUtils/UserInfoContext";
import { concatClassnames } from "../../WSUtils/util";
import { CVPSearchParams } from "../../WSUtils/wsQueryStringStore";
import { CVEditContext } from "./CVEditContext";

export const CVEditNextStepButton = observer(() => {
  const L = useLocStore(LocContext.CV);
  const cvEditContext = useContext(CVEditContext);
  const userInfo = useContext(UserInfoContext);

  const currentStep = cvEditContext.currentStep;
  const currentIndex = cvEditContext.steps.indexOf(currentStep);
  const isLastStep = currentIndex === cvEditContext.steps.length - 1;

  if (!cvEditContext.showNextStepButton) return null;

  return (
    <Button
      className={concatClassnames([
        "cve-next-step-button",
        isLastStep && "p-button-secondary",
      ])}
      label={L.id("7d25fdbde52f").loc("Neste steg")}
      icon="pi pi-arrow-right p-button-icon-right"
      disabled={isLastStep}
      onClick={action((evt) => {
        evt.preventDefault();

        redirect(null, {
          userInfo,
          mergeQs: { [CVPSearchParams.cvpstep]: (currentIndex + 2).toString() },
        });

        scrollIntoView(document.querySelector(".cve-container"));

        return false;
      })}
    />
  );
});
